'use client';

import { CheckCircle } from 'lucide-react';
import Container from '@/components/ui/container';
import * as LucideIcons from 'lucide-react';

import { setAttr } from '@directus/visual-editing';
import { parseHeading } from '@/lib/utils';

const DEFAULT_TRUST_INDICATORS = [
	{ icon: 'CheckCircle', text: 'Erkend installateur' },
	{ icon: 'CheckCircle', text: 'Jarenlange ervaring' },
	{ icon: 'CheckCircle', text: 'Vakkundig advies' },
	{ icon: 'CheckCircle', text: 'Uitstekende service' },
];

interface TrustIndicatorsProps {
	data: {
		indicators?: {
			icon: string;
			text: string;
		}[];
	};
	itemId?: string;
}

export default function TrustIndicators({ data, itemId }: TrustIndicatorsProps) {
	// Process indicators with fallback
	const indicators =
		Array.isArray(data?.indicators) && data.indicators.length > 0 ? data.indicators : DEFAULT_TRUST_INDICATORS;

	return (
		<div className="bg-white text-blue-dark py-12 border-y border-gray-100" data-directus-id={itemId}>
			<Container>
				<div
					className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8"
					{...(itemId
						? {
								'data-directus': setAttr({
									collection: 'block_trust_indicators',
									item: itemId,
									fields: ['indicators'],
								}),
							}
						: {})}
				>
					{indicators.map((item, index) => {
						// Dynamically load icon
						const IconComponent = (LucideIcons as any)[item.icon] || LucideIcons.CheckCircle;

						return (
							<div key={index} className="flex items-center space-x-4 group">
								<div className="bg-orange/10 p-2.5 rounded-full transition-colors group-hover:bg-orange/20">
									<IconComponent className="size-6 text-orange" />
								</div>
								<span className="font-semibold text-lg tracking-tight">{parseHeading(item.text)}</span>
							</div>
						);
					})}
				</div>
			</Container>
		</div>
	);
}
